import React from 'react';
import PlantObligationDefault from './PlantObligationSwitch/PlantObligationDefault';

function PlantObligationSwitch(props) {
  const {
    plantObligationID, type,
  } = props;

  // COGER EL TYPE DE LA STORE (METERLO PRIMERO ANTES CLARO)
  switch (type) {
    case 'ClientFavouritesSmall':
      return '';
    default:
      return (
        <PlantObligationDefault
          plantObligationID={plantObligationID}
        />
      );
  }
}

export default React.memo(PlantObligationSwitch);
